export default [
  {
    Authorization_Level: 'Observer ',
    Organization: 'CHA',
    Department: 'BUDGET & MANAGEMENT',
    Employee_Name: 'Jarrett, Marvin D.',
    Id: 33,
    Work_Number: '312.913.7230',
    Title: 'FINANCIAL ANALYST',
    Email_Address: 'Mjarrett@thecha.org',
  },
  {
    Email_Address: '@cclfchicago.org',
    Department: '',
    Id: 72,
    Organization: 'CCLF',
    Title: 'Senior Program Officer - Economic Development',
    Work_Number: '',
    Authorization_Level: 'Observer ',
    Employee_Name: 'Anthony D. Mosely',
  },
  {
    Work_Number: '312.786.3691',
    Employee_Name: 'Jones, Sharon D.',
    Email_Address: 'Sharjones@thecha.org',
    Organization: 'CHA',
    Department: 'SECTION 3 FIELD OFFICE',
    Title: 'SEC 3 HIRING & CONTRACT SPECIALIST',
    Authorization_Level: 'Observer ',
    Id: 46,
  },
  {
    Employee_Name: 'Amoako, Pamela',
    Id: 55,
    Organization: 'CHA',
    Authorization_Level: 'Observer ',
    Email_Address: 'pamoako@thecha.org',
    Title: 'SENIOR PROCUREMENT SPECIALIST',
    Department: 'PROCUREMENT & CONTRACTS',
    Work_Number: '312.786.6906',
  },
  {
    Department: '',
    Email_Address: 'jcalixto@cclfchicago.org',
    Authorization_Level: 'Observer ',
    Employee_Name: 'Juan Calixto',
    Title: 'Vice President of External Relations',
    Organization: 'CCLF',
    Id: 64,
    Work_Number: '',
  },
  {
    Email_Address: '@cclfchicago.org',
    Id: 78,
    Title: 'Asset Manager',
    Department: '',
    Work_Number: '',
    Authorization_Level: 'Project Manager',
    Organization: 'CCLF',
    Employee_Name: 'Aaron Akers',
  },
  {
    Authorization_Level: 'Admin',
    Department: 'DEVELOPMENT',
    Email_Address: 'AKhouri@thecha.org',
    Work_Number: '312.913.7596',
    Employee_Name: 'Khouri, Ahlam',
    Organization: 'CHA',
    Id: 18,
    Title: 'DEVELOPMENT MANAGER II',
  },
  {
    Id: 52,
    Department: 'SECTION 3 FIELD OFFICE',
    Organization: 'CHA',
    Email_Address: 'BPhillips@thecha.org',
    Work_Number: '312.786.3251',
    Authorization_Level: 'Observer ',
    Employee_Name: 'Phillips, Belinda',
    Title: 'SECTION 3 COORDINATOR',
  },
  {
    Department: 'DEVELOPMENT',
    Title: 'DEVELOPMENT MANAGER II',
    Authorization_Level: 'Admin',
    Email_Address: 'JAlvarez@thecha.org',
    Id: 17,
    Organization: 'CHA',
    Employee_Name: 'Alvarez, Jose A.',
    Work_Number: '312.913.7574',
  },
  {
    Department: '',
    Email_Address: '@cclfchicago.org',
    Work_Number: '',
    Authorization_Level: 'Project Manager',
    Employee_Name: 'Aaron Akers',
    Id: 78,
    Organization: 'CCLF',
    Title: 'Asset Manager',
  },
  {
    Department: '',
    Authorization_Level: 'Observer ',
    Title: 'Senior Loan Program Officer II',
    Employee_Name: 'James A. Norris',
    Work_Number: '',
    Email_Address: '@cclfchicago.org',
    Id: 73,
    Organization: 'CCLF',
  },
  {
    Email_Address: '@cclfchicago.org',
    Organization: 'CCLF',
    Authorization_Level: 'Admin',
    Employee_Name: 'Robin Schabes',
    Title: 'Chicagoland Opportunity Zones Consortium Director',
    Department: '',
    Work_Number: '',
    Id: 69,
  },
  {
    Work_Number: '',
    Authorization_Level: 'Observer ',
    Id: 75,
    Employee_Name: 'Allison Butts',
    Department: '',
    Email_Address: '@cclfchicago.org',
    Title: 'Loan Closing Officer',
    Organization: 'CCLF',
  },
  {
    Title: 'Portfolio Management Associate',
    Employee_Name: 'Amorita Falcon',
    Organization: 'CCLF',
    Work_Number: '',
    Authorization_Level: 'Observer ',
    Email_Address: '@cclfchicago.org',
    Department: '',
    Id: 80,
  },
  {
    Employee_Name: 'Deandre Tanner',
    Work_Number: '',
    Department: '',
    Title: 'Staff Accountant',
    Email_Address: '@cclfchicago.org',
    Authorization_Level: 'Project Manager',
    Organization: 'CCLF',
    Id: 77,
  },
  {
    Email_Address: 'TWorthy@thecha.org',
    Work_Number: '312.913.7628',
    Authorization_Level: 'Admin',
    Id: 19,
    Title: 'DEVELOPMENT MANAGER II',
    Department: 'DEVELOPMENT',
    Organization: 'CHA',
    Employee_Name: 'Worthy, Thomas',
  },
  {
    Id: 26,
    Authorization_Level: 'Observer ',
    Work_Number: '312.913.7044',
    Organization: 'CHA',
    Department: 'RESIDENT SERVICES',
    Title: 'DIRECTOR CORPORATE & EXTERNAL PARTNERSHIPS',
    Email_Address: 'KHamer@thecha.org',
    Employee_Name: 'Hamer, Kristen M.',
  },
  {
    Email_Address: 'BWard@thecha.org',
    Department: 'BUDGET & MANAGEMENT',
    Id: 34,
    Title: 'FINANCIAL ANALYST',
    Authorization_Level: 'Observer ',
    Work_Number: '312.913.7702',
    Organization: 'CHA',
    Employee_Name: 'Ward, Beverly A.',
  },
  {
    Id: 79,
    Email_Address: '@cclfchicago.org',
    Organization: 'CCLF',
    Title: 'Asset Manager',
    Authorization_Level: 'Project Manager',
    Employee_Name: 'Kelly Shelton',
    Work_Number: '',
    Department: '',
  },
  {
    Employee_Name: 'Frierson, Sherease',
    Authorization_Level: 'Project Manager',
    Title: 'PROJECT MANAGER I',
    Department: 'CAPITAL CONSTRUCTION',
    Email_Address: 'sfrierson@thecha.org',
    Id: 42,
    Work_Number: '312.786.3310',
    Organization: 'CHA',
  },
  {
    Work_Number: '',
    Employee_Name: 'Holly Kavis',
    Email_Address: '@cclfchicago.org',
    Id: 74,
    Authorization_Level: 'Observer ',
    Department: '',
    Organization: 'CCLF',
    Title: 'Loan Closing Officer',
  },
  {
    Title: 'DIRECTOR DIVERSITY POLICY',
    Email_Address: 'slever-Ortiz@thecha.org',
    Work_Number: '312.913.7788',
    Authorization_Level: 'Observer ',
    Id: 29,
    Employee_Name: 'Lever Ortiz, Sara Scarleth',
    Organization: 'CHA',
    Department: 'DIVERSITY & INCLUSION',
  },
  {
    Work_Number: '',
    Id: 77,
    Organization: 'CCLF',
    Employee_Name: 'Deandre Tanner',
    Title: 'Staff Accountant',
    Department: '',
    Email_Address: '@cclfchicago.org',
    Authorization_Level: 'Project Manager',
  },
  {
    Organization: 'CHA',
    Employee_Name: 'Alvarez, Jose A.',
    Title: 'DEVELOPMENT MANAGER II',
    Email_Address: 'JAlvarez@thecha.org',
    Department: 'DEVELOPMENT',
    Work_Number: '312.913.7574',
    Authorization_Level: 'Admin',
    Id: 17,
  },
  {
    Organization: 'CCLF',
    Authorization_Level: 'Observer ',
    Title: 'Chief Financial Officer',
    Department: '',
    Employee_Name: 'Angela Dowell',
    Work_Number: '',
    Id: 63,
    Email_Address: 'adowell@cclfchicago.org',
  },
  {
    Title: 'DIRECTOR CAPITAL CONSTRUCTION',
    Work_Number: '312.913.7324',
    Email_Address: 'DTalison@thecha.org',
    Id: 22,
    Employee_Name: 'Talison, Dennis L.',
    Organization: 'CHA',
    Authorization_Level: 'Observer ',
    Department: 'CAPITAL CONSTRUCTION',
  },
  {
    Department: 'PLANNING & REPORTING',
    Organization: 'CHA',
    Work_Number: '312.913.7836',
    Employee_Name: 'Shaide, Bridget T.',
    Id: 40,
    Email_Address: 'BTHoward@thecha.org',
    Title: 'PROJECT MANAGER',
    Authorization_Level: 'Project Manager',
  },
  {
    Email_Address: 'tbeecher@thecha.org',
    Title: 'CONSTRUCTION MANAGER II',
    Organization: 'CHA',
    Id: 12,
    Department: 'CAPITAL CONSTRUCTION',
    Authorization_Level: 'Observer ',
    Work_Number: '312.913.7176',
    Employee_Name: 'Beecher, Tyrone',
  },
  {
    Email_Address: 'KHall@thecha.org',
    Title: 'DIRECTOR DESIGN ENGINEER & PLANNING',
    Authorization_Level: 'Observer ',
    Id: 27,
    Work_Number: '312.786.7777',
    Organization: 'CHA',
    Employee_Name: 'Hall, Kevin S.',
    Department: 'CAPITAL CONSTRUCTION',
  },
  {
    Id: 40,
    Authorization_Level: 'Project Manager',
    Work_Number: '312.913.7836',
    Email_Address: 'BTHoward@thecha.org',
    Organization: 'CHA',
    Employee_Name: 'Shaide, Bridget T.',
    Title: 'PROJECT MANAGER',
    Department: 'PLANNING & REPORTING',
  },
  {
    Employee_Name: 'Rios, Miriam',
    Email_Address: 'MRios@thecha.org',
    Organization: 'CHA',
    Id: 9,
    Department: 'CAPITAL CONSTRUCTION',
    Work_Number: '312.913.7378',
    Authorization_Level: 'Observer ',
    Title: 'CONSTRUCTION MANAGER I',
  },
  {
    Employee_Name: 'Orimalade, Okediji',
    Email_Address: 'OOrimalade@thecha.org',
    Department: 'SECTION 3 FIELD OFFICE',
    Organization: 'CHA',
    Work_Number: '312.913.7358',
    Title: 'SEC 3 HIRING & CONTRACT SPECIALIST',
    Authorization_Level: 'Observer ',
    Id: 47,
  },
  {
    Title: 'DEVELOPMENT MONITORING MANAGER',
    Id: 20,
    Work_Number: '312.786.3316',
    Authorization_Level: 'Admin',
    Employee_Name: 'Latham, Michelle A.',
    Email_Address: 'MHarrington@thecha.org',
    Department: 'DEVELOPMENT',
    Organization: 'CHA',
  },
  {
    Organization: 'CHA',
    Department: 'CAPITAL CONSTRUCTION',
    Title: 'CONSTRUCTION MANAGER I',
    Email_Address: 'jotekiela@thecha.org',
    Employee_Name: 'Tekiela, Joseph K.',
    Authorization_Level: 'Observer ',
    Id: 11,
    Work_Number: '312.786.6918',
  },
  {
    Id: 52,
    Work_Number: '312.786.3251',
    Email_Address: 'BPhillips@thecha.org',
    Employee_Name: 'Phillips, Belinda',
    Authorization_Level: 'Observer ',
    Department: 'SECTION 3 FIELD OFFICE',
    Organization: 'CHA',
    Title: 'SECTION 3 COORDINATOR',
  },
  {
    Employee_Name: 'Sean Harden',
    Work_Number: '',
    Department: '',
    Organization: 'CCLF',
    Title: 'TA and Special Initiative Consultant ',
    Email_Address: '@cclfchicago.org',
    Authorization_Level: 'Observer ',
    Id: 82,
  },
  {
    Authorization_Level: 'Observer ',
    Id: 64,
    Email_Address: 'jcalixto@cclfchicago.org',
    Department: '',
    Employee_Name: 'Juan Calixto',
    Work_Number: '',
    Organization: 'CCLF',
    Title: 'Vice President of External Relations',
  },
  {
    Work_Number: '312.913.7378',
    Authorization_Level: 'Observer ',
    Organization: 'CHA',
    Title: 'CONSTRUCTION MANAGER I',
    Email_Address: 'MRios@thecha.org',
    Id: 9,
    Employee_Name: 'Rios, Miriam',
    Department: 'CAPITAL CONSTRUCTION',
  },
  {
    Department: 'DIVERSITY & INCLUSION',
    Employee_Name: 'Justo, Raul',
    Authorization_Level: 'Observer ',
    Title: 'PROJECT MANAGER I',
    Email_Address: 'RJusto@thecha.org',
    Id: 45,
    Work_Number: '312.786.6686',
    Organization: 'CHA',
  },
  {
    Employee_Name: 'Orimalade, Okediji',
    Email_Address: 'OOrimalade@thecha.org',
    Authorization_Level: 'Observer ',
    Work_Number: '312.913.7358',
    Department: 'SECTION 3 FIELD OFFICE',
    Id: 47,
    Title: 'SEC 3 HIRING & CONTRACT SPECIALIST',
    Organization: 'CHA',
  },
  {
    Id: 32,
    Authorization_Level: 'Observer ',
    Organization: 'CHA',
    Email_Address: 'lholcomb@thecha.org',
    Employee_Name: 'Holcomb, Latrice',
    Title: 'FINANCIAL ANALYST',
    Work_Number: '312.913.7244',
    Department: 'BUDGET & MANAGEMENT',
  },
  {
    Department: 'DIVERSITY & INCLUSION',
    Email_Address: 'ACochran@thecha.org',
    Authorization_Level: 'Project Manager',
    Title: 'PROJECT MANAGER I',
    Id: 44,
    Employee_Name: 'Cochran, Ashley',
    Organization: 'CHA',
    Work_Number: '312.786.3695',
  },
  {
    Employee_Name: 'Townes, Jordan D.',
    Authorization_Level: 'Observer ',
    Organization: 'CHA',
    Work_Number: '312.913.7362',
    Email_Address: 'JTownes@thecha.org',
    Title: 'DIRECTOR CAPITAL BUDGET & CONTROL',
    Id: 21,
    Department: 'BUDGET & MANAGEMENT',
  },
  {
    Authorization_Level: 'Observer ',
    Id: 30,
    Email_Address: 'dabeale@thecha.org',
    Department: 'BUDGET & MANAGEMENT',
    Employee_Name: 'Beale, Dana',
    Title: 'FINANCIAL ANALYST',
    Organization: 'CHA',
    Work_Number: '312.913.7626',
  },
  {
    Organization: 'CHA',
    Id: 18,
    Title: 'DEVELOPMENT MANAGER II',
    Authorization_Level: 'Admin',
    Work_Number: '312.913.7596',
    Employee_Name: 'Khouri, Ahlam',
    Department: 'DEVELOPMENT',
    Email_Address: 'AKhouri@thecha.org',
  },
  {
    Employee_Name: 'Deborah Sabol',
    Title: 'Director of Operations',
    Authorization_Level: 'Admin',
    Id: 68,
    Department: '',
    Organization: 'CCLF',
    Email_Address: '@cclfchicago.org',
    Work_Number: '',
  },
  {
    Title: 'PROJECT MANAGER I',
    Id: 42,
    Authorization_Level: 'Project Manager',
    Organization: 'CHA',
    Employee_Name: 'Frierson, Sherease',
    Department: 'CAPITAL CONSTRUCTION',
    Work_Number: '312.786.3310',
    Email_Address: 'sfrierson@thecha.org',
  },
  {
    Id: 13,
    Employee_Name: 'Feliciano, Wilfredo',
    Organization: 'CHA',
    Email_Address: 'wifeliciano@thecha.org',
    Department: 'CAPITAL CONSTRUCTION',
    Title: 'CONSTRUCTION MANAGER II',
    Work_Number: '312.913.7730',
    Authorization_Level: 'Observer ',
  },
  {
    Authorization_Level: 'Observer ',
    Title: 'FINANCIAL ANALYST',
    Department: 'BUDGET & MANAGEMENT',
    Organization: 'CHA',
    Email_Address: 'Mjarrett@thecha.org',
    Employee_Name: 'Jarrett, Marvin D.',
    Id: 33,
    Work_Number: '312.913.7230',
  },
  {
    Authorization_Level: 'Observer ',
    Id: 62,
    Employee_Name: 'Robert Tucker',
    Work_Number: '',
    Title: 'COO and Executive Vice President of Programs',
    Email_Address: 'rtucker@cclfchicago.org',
    Organization: 'CCLF',
    Department: '',
  },
  {
    Work_Number: '312.913.7918',
    Organization: 'CHA',
    Authorization_Level: 'Observer ',
    Department: 'GENERAL COUNSEL',
    Email_Address: 'ccolston@thecha.org',
    Employee_Name: 'Colston, Cheryl J.',
    Title: 'CHIEF LEGAL OFFICER',
    Id: 7,
  },
  {
    Organization: 'CHA',
    Title: 'CHIEF DEVELOPMENT OFFICER',
    Work_Number: '312.913.7656',
    Email_Address: 'amckenzie@thecha.org',
    Employee_Name: 'McKenzie, Ann C.',
    Id: 3,
    Department: 'DEVELOPMENT',
    Authorization_Level: 'Admin',
  },
  {
    Employee_Name: 'Angela Dowell',
    Email_Address: 'adowell@cclfchicago.org',
    Title: 'Chief Financial Officer',
    Work_Number: '',
    Department: '',
    Authorization_Level: 'Observer ',
    Organization: 'CCLF',
    Id: 63,
  },
  {
    Work_Number: '312.913.7442',
    Department: "COMPTROLLER'S OFFICE",
    Authorization_Level: 'Observer ',
    Organization: 'CHA',
    Employee_Name: 'Wiseman, Jeffrey L.',
    Email_Address: 'JWiseman@thecha.org',
    Title: 'FINANCIAL ANALYST',
    Id: 37,
  },
  {
    Id: 45,
    Work_Number: '312.786.6686',
    Title: 'PROJECT MANAGER I',
    Organization: 'CHA',
    Email_Address: 'RJusto@thecha.org',
    Employee_Name: 'Justo, Raul',
    Authorization_Level: 'Observer ',
    Department: 'DIVERSITY & INCLUSION',
  },
  {
    Id: 70,
    Email_Address: '@cclfchicago.org',
    Department: '',
    Organization: 'CCLF',
    Authorization_Level: 'Admin',
    Employee_Name: 'Candace M. Gregory',
    Title: 'Accounting Manager',
    Work_Number: '',
  },
  {
    Id: 4,
    Email_Address: 'mmoran@thecha.org',
    Title: 'CHIEF FINANCIAL OFFICER',
    Work_Number: '312.913-7012',
    Employee_Name: 'Moran, Michael',
    Authorization_Level: 'Observer ',
    Department: 'CHIEF FINANCIAL OFFICER',
    Organization: 'CHA',
  },
  {
    Work_Number: '312.786.7666',
    Authorization_Level: 'Project Manager',
    Email_Address: 'gbarrera@thecha.org',
    Employee_Name: 'Barrera, George',
    Id: 41,
    Organization: 'CHA',
    Department: 'CAPITAL CONSTRUCTION',
    Title: 'PROJECT MANAGER CONSTRUCTION',
  },
  {
    Work_Number: '312.913.7486',
    Id: 54,
    Employee_Name: 'Aikens, Sheena',
    Authorization_Level: 'Observer ',
    Title: 'SENIOR PROCUREMENT SPECIALIST',
    Organization: 'CHA',
    Department: 'PROCUREMENT & CONTRACTS',
    Email_Address: 'Saikens@thecha.org',
  },
  {
    Work_Number: '312.913.7202',
    Authorization_Level: 'Observer ',
    Organization: 'CHA',
    Email_Address: 'amturner@thecha.org',
    Title: 'SECTION 3 COORDINATOR',
    Department: 'SECTION 3 FIELD OFFICE',
    Employee_Name: 'Turner, Antwanette',
    Id: 53,
  },
  {
    Work_Number: '312.786.4022',
    Authorization_Level: 'Observer',
    Id: 1,
    Organization: 'CHA',
    Department: 'CHIEF ADMINISTRATIVE OFFICE',
    Email_Address: 'PRios@thecha.org',
    Employee_Name: 'Rios, Patricia',
    Title: 'CHIEF ADMINISTRATIVE OFFICER',
  },
  {
    Organization: 'CHA',
    Authorization_Level: 'Observer ',
    Title: 'DIRECTOR COMPLIANCE & OPERATIONS',
    Employee_Name: 'Santiago, Milton',
    Department: 'HOUSING CHOICE VOUCHER PORTFOLIO',
    Work_Number: '312.786.3161',
    Id: 25,
    Email_Address: 'MaSantiago@thecha.org',
  },
  {
    Work_Number: '312.935.2662',
    Employee_Name: 'Broman, Robin S.',
    Authorization_Level: 'Admin',
    Id: 15,
    Department: 'DEVELOPMENT',
    Email_Address: 'RBroman@thecha.org',
    Title: 'DEVELOPMENT MANAGER',
    Organization: 'CHA',
  },
  {
    Work_Number: '312.913.7505',
    Id: 43,
    Authorization_Level: 'Project Manager',
    Department: 'CAPITAL CONSTRUCTION',
    Title: 'PROJECT MANAGER I',
    Organization: 'CHA',
    Employee_Name: 'Lamm, Kevin',
    Email_Address: 'Klamm@thecha.org',
  },
  {
    Department: '',
    Organization: 'CCLF',
    Title: 'President',
    Work_Number: '',
    Employee_Name: 'Calvin L. Holmes',
    Id: 61,
    Email_Address: 'cholmes@cclfchicago.org',
    Authorization_Level: 'Observer ',
  },
  {
    Organization: 'CCLF',
    Authorization_Level: 'Observer ',
    Department: '',
    Id: 71,
    Employee_Name: 'Pamela Graves',
    Email_Address: '@cclfchicago.org',
    Title: 'Marketing and Communications Manager',
    Work_Number: '',
  },
  {
    Work_Number: '312.913.7626',
    Email_Address: 'dabeale@thecha.org',
    Title: 'FINANCIAL ANALYST',
    Id: 30,
    Authorization_Level: 'Observer ',
    Department: 'BUDGET & MANAGEMENT',
    Employee_Name: 'Beale, Dana',
    Organization: 'CHA',
  },
  {
    Authorization_Level: 'Observer ',
    Id: 28,
    Organization: 'CHA',
    Title: 'DIRECTOR DEVELOPMENT CONSTRUCTION',
    Employee_Name: 'Borkgren, Brent',
    Department: 'CAPITAL CONSTRUCTION',
    Work_Number: '312.913.7662',
    Email_Address: 'BBorkgren@thecha.org',
  },
  {
    Title: 'CHIEF DEVELOPMENT OFFICER',
    Department: 'DEVELOPMENT',
    Id: 3,
    Employee_Name: 'McKenzie, Ann C.',
    Organization: 'CHA',
    Authorization_Level: 'Admin',
    Work_Number: '312.913.7656',
    Email_Address: 'amckenzie@thecha.org',
  },
  {
    Work_Number: '312.542.8870',
    Id: 48,
    Organization: 'CHA',
    Department: 'SECTION 3 FIELD OFFICE',
    Authorization_Level: 'Observer ',
    Employee_Name: 'Phillips, Brandy S.',
    Title: 'SEC 3 HIRING & CONTRACT SPECIALIST',
    Email_Address: 'brphillips@thecha.org',
  },
  {
    Authorization_Level: 'Observer ',
    Employee_Name: 'Ricketts, Michael',
    Id: 49,
    Title: 'SECTION 3 APPLICATION TRAINER',
    Work_Number: '312.786.3336',
    Organization: 'CHA',
    Email_Address: 'mricketts@thecha.org',
    Department: 'SECTION 3 FIELD OFFICE',
  },
  {
    Organization: 'CCLF',
    Work_Number: '',
    Title: 'President',
    Email_Address: 'cholmes@cclfchicago.org',
    Employee_Name: 'Calvin L. Holmes',
    Authorization_Level: 'Observer ',
    Id: 61,
    Department: '',
  },
  {
    Employee_Name: 'Wendell Harris',
    Id: 67,
    Email_Address: '@cclfchicago.org',
    Work_Number: '',
    Title: 'Vice President of Lending Operations',
    Authorization_Level: 'Observer ',
    Department: '',
    Organization: 'CCLF',
  },
  {
    Authorization_Level: 'Observer ',
    Organization: 'CCLF',
    Employee_Name: 'Allison Butts',
    Work_Number: '',
    Title: 'Loan Closing Officer',
    Email_Address: '@cclfchicago.org',
    Id: 75,
    Department: '',
  },
  {
    Organization: 'CCLF',
    Employee_Name: 'Maya Chandler',
    Email_Address: '@cclfchicago.org',
    Authorization_Level: 'Project Manager',
    Id: 76,
    Work_Number: '',
    Title: 'Senior Accountant',
    Department: '',
  },
  {
    Email_Address: 'BLand@thecha.org',
    Authorization_Level: 'Observer ',
    Id: 5,
    Employee_Name: 'Land, Bryan K',
    Title: 'CHIEF INFORMATION TECHNOLOGY OFFICER',
    Organization: 'CHA',
    Work_Number: '312.913.7272',
    Department: 'INFORMATION TECHNOLOGY',
  },
  {
    Department: 'CAPITAL CONSTRUCTION',
    Authorization_Level: 'Observer ',
    Email_Address: 'MLaud@thecha.org',
    Work_Number: '312.913.7364',
    Title: 'CONSTRUCTION MANAGER II',
    Id: 14,
    Organization: 'CHA',
    Employee_Name: 'Laud, Manuel L.',
  },
  {
    Department: '',
    Work_Number: '',
    Email_Address: '@cclfchicago.org',
    Employee_Name: 'James A. Norris',
    Title: 'Senior Loan Program Officer II',
    Organization: 'CCLF',
    Authorization_Level: 'Observer ',
    Id: 73,
  },
  {
    Organization: 'CHA',
    Title: 'CHIEF LEGAL OFFICER',
    Work_Number: '312.913.7918',
    Department: 'GENERAL COUNSEL',
    Employee_Name: 'Colston, Cheryl J.',
    Authorization_Level: 'Observer ',
    Id: 7,
    Email_Address: 'ccolston@thecha.org',
  },
  {
    Department: 'DEVELOPMENT',
    Employee_Name: 'Broman, Robin S.',
    Work_Number: '312.935.2662',
    Id: 15,
    Organization: 'CHA',
    Email_Address: 'RBroman@thecha.org',
    Title: 'DEVELOPMENT MANAGER',
    Authorization_Level: 'Admin',
  },
  {
    Department: 'FAMILY INVESTMENT CENTER',
    Id: 23,
    Employee_Name: 'Swann-Thompson, Shemika',
    Work_Number: '312.786.6986',
    Authorization_Level: 'Observer ',
    Email_Address: 'sswann@thecha.org',
    Organization: 'CHA',
    Title: 'DIRECTOR COMMERCIAL PROPERTIES',
  },
  {
    Id: 26,
    Work_Number: '312.913.7044',
    Email_Address: 'KHamer@thecha.org',
    Organization: 'CHA',
    Title: 'DIRECTOR CORPORATE & EXTERNAL PARTNERSHIPS',
    Department: 'RESIDENT SERVICES',
    Authorization_Level: 'Observer ',
    Employee_Name: 'Hamer, Kristen M.',
  },
  {
    Organization: 'Organization',
    Department: 'Department',
    Authorization_Level: 'Authorization_Level',
    Title: 'Title',
    Id: 'Id',
    Email_Address: 'Email_Address',
    Employee_Name: 'Employee_Name',
    Work_Number: 'Work_Number',
  },
  {
    Email_Address: 'MGurgone@thecha.org',
    Id: 6,
    Organization: 'CHA',
    Department: 'TREASURY DEPARTMENT',
    Work_Number: '312.786.4096',
    Authorization_Level: 'Observer ',
    Employee_Name: 'Gurgone, Michael',
    Title: 'CHIEF INVESTMENT OFFICER',
  },
  {
    Id: 2,
    Organization: 'CHA',
    Employee_Name: 'Mosher, Matthew T.',
    Title: 'CHIEF CONSTUCTION OFFICER',
    Authorization_Level: 'Admin',
    Department: 'CAPITAL CONSTRUCTION',
    Email_Address: 'mmosher@thecha.org',
    Work_Number: '312.913.7250',
  },
  {
    Department: 'CHIEF FINANCIAL OFFICER',
    Employee_Name: 'Moran, Michael',
    Organization: 'CHA',
    Authorization_Level: 'Observer ',
    Title: 'CHIEF FINANCIAL OFFICER',
    Email_Address: 'mmoran@thecha.org',
    Id: 4,
    Work_Number: '312.913-7012',
  },
  {
    Authorization_Level: 'Observer ',
    Email_Address: 'elollar@thecha.org',
    Work_Number: '312.786.3119',
    Id: 35,
    Department: "COMPTROLLER'S OFFICE",
    Employee_Name: 'Lollar, Ervin',
    Organization: 'CHA',
    Title: 'FINANCIAL ANALYST',
  },
  {
    Employee_Name: 'Jones, Sharon D.',
    Email_Address: 'Sharjones@thecha.org',
    Id: 46,
    Department: 'SECTION 3 FIELD OFFICE',
    Organization: 'CHA',
    Authorization_Level: 'Observer ',
    Work_Number: '312.786.3691',
    Title: 'SEC 3 HIRING & CONTRACT SPECIALIST',
  },
  {
    Authorization_Level: 'Observer ',
    Department: 'DEVELOPMENT',
    Email_Address: 'rfernandez@thecha.org',
    Organization: 'CHA',
    Work_Number: '312.786.3182',
    Id: 38,
    Employee_Name: 'Fernandez, Raul R.',
    Title: 'FINANCIAL ANALYST',
  },
  {
    Organization: 'CCLF',
    Authorization_Level: 'Admin',
    Id: 68,
    Title: 'Director of Operations',
    Email_Address: '@cclfchicago.org',
    Department: '',
    Work_Number: '',
    Employee_Name: 'Deborah Sabol',
  },
  {
    Authorization_Level: 'Observer ',
    Organization: 'CHA',
    Department: 'BUDGET & MANAGEMENT',
    Title: 'FINANCIAL ANALYST',
    Id: 32,
    Work_Number: '312.913.7244',
    Email_Address: 'lholcomb@thecha.org',
    Employee_Name: 'Holcomb, Latrice',
  },
  {
    Department: 'CAPITAL CONSTRUCTION',
    Authorization_Level: 'Admin',
    Work_Number: '312.913.7250',
    Title: 'CHIEF CONSTUCTION OFFICER',
    Email_Address: 'mmosher@thecha.org',
    Organization: 'CHA',
    Employee_Name: 'Mosher, Matthew T.',
    Id: 2,
  },
  {
    Id: 16,
    Authorization_Level: 'Admin',
    Title: 'DEVELOPMENT MANAGER',
    Email_Address: 'abrooks@thecha.org',
    Organization: 'CHA',
    Department: 'DEVELOPMENT',
    Employee_Name: 'Brooks, Angela D.',
    Work_Number: '312.786.3246',
  },
  {
    Id: 24,
    Email_Address: 'MPlummer@thecha.org',
    Title: 'DIRECTOR COMMUNITY SUPPORT',
    Authorization_Level: 'Observer ',
    Organization: 'CHA',
    Employee_Name: 'Plummer, Mark A.',
    Department: 'RESIDENT SERVICES',
    Work_Number: '312.913.7404',
  },
  {
    Organization: 'CHA',
    Employee_Name: 'Lamm, Kevin',
    Authorization_Level: 'Project Manager',
    Department: 'CAPITAL CONSTRUCTION',
    Title: 'PROJECT MANAGER I',
    Id: 43,
    Work_Number: '312.913.7505',
    Email_Address: 'Klamm@thecha.org',
  },
  {
    Title: 'SENIOR PROCUREMENT SPECIALIST',
    Id: 58,
    Email_Address: 'PSeanior@thecha.org',
    Work_Number: '312.913.5854',
    Authorization_Level: 'Observer ',
    Organization: 'CHA',
    Employee_Name: 'Seanior, Pamela D.',
    Department: 'PROCUREMENT & CONTRACTS',
  },
  {
    Work_Number: '312.786.6906',
    Email_Address: 'pamoako@thecha.org',
    Department: 'PROCUREMENT & CONTRACTS',
    Title: 'SENIOR PROCUREMENT SPECIALIST',
    Authorization_Level: 'Observer ',
    Id: 55,
    Employee_Name: 'Amoako, Pamela',
    Organization: 'CHA',
  },
  {
    Organization: 'CHA',
    Authorization_Level: 'Observer ',
    Department: "COMPTROLLER'S OFFICE",
    Employee_Name: 'Lollar, Ervin',
    Title: 'FINANCIAL ANALYST',
    Id: 35,
    Work_Number: '312.786.3119',
    Email_Address: 'elollar@thecha.org',
  },
  {
    Email_Address: 'DTalison@thecha.org',
    Work_Number: '312.913.7324',
    Id: 22,
    Department: 'CAPITAL CONSTRUCTION',
    Organization: 'CHA',
    Authorization_Level: 'Observer ',
    Title: 'DIRECTOR CAPITAL CONSTRUCTION',
    Employee_Name: 'Talison, Dennis L.',
  },
  {
    Employee_Name: 'Gurgone, Michael',
    Id: 6,
    Email_Address: 'MGurgone@thecha.org',
    Department: 'TREASURY DEPARTMENT',
    Work_Number: '312.786.4096',
    Organization: 'CHA',
    Title: 'CHIEF INVESTMENT OFFICER',
    Authorization_Level: 'Observer ',
  },
  {
    Title: 'Senior Accountant',
    Organization: 'CCLF',
    Department: '',
    Id: 76,
    Email_Address: '@cclfchicago.org',
    Authorization_Level: 'Project Manager',
    Employee_Name: 'Maya Chandler',
    Work_Number: '',
  },
  {
    Work_Number: '312.913.5874',
    Title: 'SECTION 3 COMPLIANCE MANAGER',
    Department: 'SECTION 3 FIELD OFFICE',
    Employee_Name: 'Scott, Johnetta M.',
    Organization: 'CHA',
    Authorization_Level: 'Observer ',
    Email_Address: 'JMScott@thecha.org',
    Id: 50,
  },
  {
    Email_Address: '@cclfchicago.org',
    Authorization_Level: 'Observer ',
    Work_Number: '',
    Employee_Name: 'Sean Harden',
    Organization: 'CCLF',
    Department: '',
    Id: 82,
    Title: 'TA and Special Initiative Consultant ',
  },
  {
    Title: 'PROJECT MANAGER CONSTRUCTION',
    Email_Address: 'gbarrera@thecha.org',
    Organization: 'CHA',
    Authorization_Level: 'Project Manager',
    Employee_Name: 'Barrera, George',
    Department: 'CAPITAL CONSTRUCTION',
    Work_Number: '312.786.7666',
    Id: 41,
  },
  {
    Id: 71,
    Title: 'Marketing and Communications Manager',
    Email_Address: '@cclfchicago.org',
    Authorization_Level: 'Observer ',
    Employee_Name: 'Pamela Graves',
    Department: '',
    Work_Number: '',
    Organization: 'CCLF',
  },
  {
    Email_Address: '@cclfchicago.org',
    Employee_Name: 'Maurice Williams',
    Work_Number: '',
    Title: 'Vice President of Economic Development',
    Authorization_Level: 'Observer ',
    Id: 65,
    Department: '',
    Organization: 'CCLF',
  },
  {
    Organization: 'CHA',
    Work_Number: '312.913.7442',
    Authorization_Level: 'Observer ',
    Email_Address: 'stslaughter@thecha.org',
    Id: 39,
    Employee_Name: 'Slaughter, Stephanie',
    Title: 'FINANCIAL ANALYST',
    Department: 'DEVELOPMENT',
  },
  {
    Email_Address: '@cclfchicago.org',
    Work_Number: '',
    Organization: 'CCLF',
    Employee_Name: 'Holly Kavis',
    Title: 'Loan Closing Officer',
    Department: '',
    Id: 74,
    Authorization_Level: 'Observer ',
  },
  {
    Email_Address: '@cclfchicago.org',
    Department: '',
    Work_Number: '',
    Title: 'Accounting Manager',
    Employee_Name: 'Candace M. Gregory',
    Organization: 'CCLF',
    Id: 70,
    Authorization_Level: 'Admin',
  },
  {
    Title: 'SECTION 3 COORDINATOR',
    Work_Number: '312.913.7202',
    Department: 'SECTION 3 FIELD OFFICE',
    Organization: 'CHA',
    Authorization_Level: 'Observer ',
    Email_Address: 'amturner@thecha.org',
    Id: 53,
    Employee_Name: 'Turner, Antwanette',
  },
  {
    Organization: 'CHA',
    Employee_Name: 'Schauer, Jack',
    Authorization_Level: 'Observer ',
    Email_Address: 'jaschauer@thecha.org',
    Id: 10,
    Department: 'CAPITAL CONSTRUCTION',
    Title: 'CONSTRUCTION MANAGER I',
    Work_Number: '312.786.7860',
  },
  {
    Organization: 'CHA',
    Work_Number: '312.913.7724',
    Email_Address: 'cclopez@thecha.org',
    Employee_Name: 'Lopez, Carolina C.',
    Department: 'SECTION 3 FIELD OFFICE',
    Id: 51,
    Title: 'SECTION 3 COORDINATOR',
    Authorization_Level: 'Observer ',
  },
  {
    Authorization_Level: 'Observer ',
    Work_Number: '',
    Organization: 'CCLF',
    Email_Address: '@cclfchicago.org',
    Employee_Name: 'Chelsi Cicekoglu',
    Department: '',
    Id: 81,
    Title: 'Lending Consultant',
  },
  {
    Department: 'DEVELOPMENT',
    Work_Number: '312.913.7442',
    Id: 39,
    Title: 'FINANCIAL ANALYST',
    Email_Address: 'stslaughter@thecha.org',
    Organization: 'CHA',
    Employee_Name: 'Slaughter, Stephanie',
    Authorization_Level: 'Observer ',
  },
  {
    Authorization_Level: 'Admin',
    Title: 'DEPUTY CHIEF DEVELOPMMENET OFFICER',
    Work_Number: '312.913.7740',
    Employee_Name: 'Pratter, Lee E.',
    Department: 'DEVELOPMENT',
    Email_Address: 'LPratter@thecha.org',
    Organization: 'CHA',
    Id: 59,
  },
  {
    Department: 'Department',
    Work_Number: 'Work_Number',
    Title: 'Title',
    Organization: 'Organization',
    Authorization_Level: 'Authorization_Level',
    Email_Address: 'Email_Address',
    Employee_Name: 'Employee_Name',
    Id: 'Id',
  },
  {
    Department: "COMPTROLLER'S OFFICE",
    Title: 'FINANCIAL ANALYST',
    Authorization_Level: 'Observer ',
    Work_Number: '312.913.7538',
    Employee_Name: 'Muhammad, Bernard',
    Email_Address: 'bemuhammad@thecha.org',
    Id: 36,
    Organization: 'CHA',
  },
  {
    Email_Address: 'tsanchez@thecha.org',
    Title: 'DEPUTY CHIEF DEVELOPMMENET OFFICER',
    Organization: 'CHA',
    Work_Number: '312.786.3418',
    Department: 'DEVELOPMENT',
    Id: 60,
    Employee_Name: 'Sanchez, Tracy L.',
    Authorization_Level: 'Admin',
  },
  {
    Authorization_Level: 'Project Manager',
    Title: 'Asset Manager',
    Id: 79,
    Organization: 'CCLF',
    Email_Address: '@cclfchicago.org',
    Employee_Name: 'Kelly Shelton',
    Work_Number: '',
    Department: '',
  },
  {
    Employee_Name: 'Santiago, Milton',
    Department: 'HOUSING CHOICE VOUCHER PORTFOLIO',
    Email_Address: 'MaSantiago@thecha.org',
    Id: 25,
    Organization: 'CHA',
    Title: 'DIRECTOR COMPLIANCE & OPERATIONS',
    Authorization_Level: 'Observer ',
    Work_Number: '312.786.3161',
  },
  {
    Authorization_Level: 'Project Manager',
    Work_Number: '312.786.3695',
    Email_Address: 'ACochran@thecha.org',
    Organization: 'CHA',
    Title: 'PROJECT MANAGER I',
    Employee_Name: 'Cochran, Ashley',
    Id: 44,
    Department: 'DIVERSITY & INCLUSION',
  },
  {
    Organization: 'CCLF',
    Email_Address: '@cclfchicago.org',
    Authorization_Level: 'Observer ',
    Work_Number: '',
    Id: 81,
    Employee_Name: 'Chelsi Cicekoglu',
    Title: 'Lending Consultant',
    Department: '',
  },
  {
    Authorization_Level: 'Observer ',
    Title: 'CHIEF INFORMATION TECHNOLOGY OFFICER',
    Work_Number: '312.913.7272',
    Employee_Name: 'Land, Bryan K',
    Department: 'INFORMATION TECHNOLOGY',
    Organization: 'CHA',
    Id: 5,
    Email_Address: 'BLand@thecha.org',
  },
  {
    Authorization_Level: 'Observer ',
    Department: '',
    Work_Number: '',
    Employee_Name: 'Amorita Falcon',
    Email_Address: '@cclfchicago.org',
    Organization: 'CCLF',
    Id: 80,
    Title: 'Portfolio Management Associate',
  },
  {
    Employee_Name: 'Hall, Kevin S.',
    Organization: 'CHA',
    Work_Number: '312.786.7777',
    Authorization_Level: 'Observer ',
    Id: 27,
    Department: 'CAPITAL CONSTRUCTION',
    Email_Address: 'KHall@thecha.org',
    Title: 'DIRECTOR DESIGN ENGINEER & PLANNING',
  },
  {
    Work_Number: '312.786.7860',
    Department: 'CAPITAL CONSTRUCTION',
    Email_Address: 'jaschauer@thecha.org',
    Organization: 'CHA',
    Employee_Name: 'Schauer, Jack',
    Id: 10,
    Title: 'CONSTRUCTION MANAGER I',
    Authorization_Level: 'Observer ',
  },
  {
    Email_Address: 'Aepps@thecha.org',
    Work_Number: '312.786.3420',
    Employee_Name: 'Epps, Anna',
    Authorization_Level: 'Observer ',
    Id: 56,
    Organization: 'CHA',
    Department: 'PROCUREMENT & CONTRACTS',
    Title: 'SENIOR PROCUREMENT SPECIALIST',
  },
  {
    Organization: 'CHA',
    Id: 8,
    Authorization_Level: 'Observer ',
    Email_Address: 'jbebley@thecha.org',
    Department: 'EXECUTIVE OFFICE',
    Work_Number: '312.913.7116',
    Employee_Name: 'Bebley, James L.',
    Title: 'CHIEF OPERATING OFFICER',
  },
  {
    Email_Address: 'JTownes@thecha.org',
    Organization: 'CHA',
    Authorization_Level: 'Observer ',
    Work_Number: '312.913.7362',
    Id: 21,
    Department: 'BUDGET & MANAGEMENT',
    Title: 'DIRECTOR CAPITAL BUDGET & CONTROL',
    Employee_Name: 'Townes, Jordan D.',
  },
  {
    Authorization_Level: 'Observer ',
    Work_Number: '312.913.7730',
    Employee_Name: 'Feliciano, Wilfredo',
    Organization: 'CHA',
    Id: 13,
    Title: 'CONSTRUCTION MANAGER II',
    Email_Address: 'wifeliciano@thecha.org',
    Department: 'CAPITAL CONSTRUCTION',
  },
  {
    Title: 'FINANCIAL ANALYST',
    Id: 38,
    Work_Number: '312.786.3182',
    Employee_Name: 'Fernandez, Raul R.',
    Organization: 'CHA',
    Department: 'DEVELOPMENT',
    Email_Address: 'rfernandez@thecha.org',
    Authorization_Level: 'Observer ',
  },
  {
    Organization: 'CHA',
    Id: 49,
    Email_Address: 'mricketts@thecha.org',
    Employee_Name: 'Ricketts, Michael',
    Title: 'SECTION 3 APPLICATION TRAINER',
    Authorization_Level: 'Observer ',
    Work_Number: '312.786.3336',
    Department: 'SECTION 3 FIELD OFFICE',
  },
  {
    Work_Number: '312.786.3246',
    Organization: 'CHA',
    Email_Address: 'abrooks@thecha.org',
    Id: 16,
    Title: 'DEVELOPMENT MANAGER',
    Department: 'DEVELOPMENT',
    Authorization_Level: 'Admin',
    Employee_Name: 'Brooks, Angela D.',
  },
  {
    Email_Address: '@cclfchicago.org',
    Work_Number: '',
    Organization: 'CCLF',
    Employee_Name: 'Robin Schabes',
    Id: 69,
    Authorization_Level: 'Admin',
    Title: 'Chicagoland Opportunity Zones Consortium Director',
    Department: '',
  },
  {
    Work_Number: '312.913.5874',
    Organization: 'CHA',
    Authorization_Level: 'Observer ',
    Title: 'SECTION 3 COMPLIANCE MANAGER',
    Employee_Name: 'Scott, Johnetta M.',
    Id: 50,
    Department: 'SECTION 3 FIELD OFFICE',
    Email_Address: 'JMScott@thecha.org',
  },
  {
    Work_Number: '312.913.7176',
    Authorization_Level: 'Observer ',
    Employee_Name: 'Beecher, Tyrone',
    Department: 'CAPITAL CONSTRUCTION',
    Title: 'CONSTRUCTION MANAGER II',
    Id: 12,
    Email_Address: 'tbeecher@thecha.org',
    Organization: 'CHA',
  },
  {
    Email_Address: '@cclfchicago.org',
    Department: '',
    Work_Number: '',
    Id: 66,
    Title: 'Vice President of Portfolio Management',
    Authorization_Level: 'Observer ',
    Employee_Name: 'Lycrecia Parks',
    Organization: 'CCLF',
  },
  {
    Id: 19,
    Organization: 'CHA',
    Authorization_Level: 'Admin',
    Email_Address: 'TWorthy@thecha.org',
    Department: 'DEVELOPMENT',
    Employee_Name: 'Worthy, Thomas',
    Work_Number: '312.913.7628',
    Title: 'DEVELOPMENT MANAGER II',
  },
  {
    Email_Address: 'DLovelace@thecha.org',
    Authorization_Level: 'Observer ',
    Id: 57,
    Organization: 'CHA',
    Department: 'PROCUREMENT & CONTRACTS',
    Work_Number: '312.786.3198',
    Employee_Name: 'Lovelace, Dorthea',
    Title: 'SENIOR PROCUREMENT SPECIALIST',
  },
  {
    Work_Number: '',
    Department: '',
    Organization: 'CCLF',
    Authorization_Level: 'Observer ',
    Email_Address: '@cclfchicago.org',
    Title: 'Vice President of Portfolio Management',
    Id: 66,
    Employee_Name: 'Lycrecia Parks',
  },
  {
    Authorization_Level: 'Observer ',
    Organization: 'CHA',
    Department: 'PROCUREMENT & CONTRACTS',
    Email_Address: 'DLovelace@thecha.org',
    Employee_Name: 'Lovelace, Dorthea',
    Id: 57,
    Work_Number: '312.786.3198',
    Title: 'SENIOR PROCUREMENT SPECIALIST',
  },
  {
    Email_Address: '@cclfchicago.org',
    Id: 72,
    Title: 'Senior Program Officer - Economic Development',
    Organization: 'CCLF',
    Employee_Name: 'Anthony D. Mosely',
    Work_Number: '',
    Department: '',
    Authorization_Level: 'Observer ',
  },
  {
    Title: 'FINANCIAL ANALYST',
    Department: "COMPTROLLER'S OFFICE",
    Organization: 'CHA',
    Email_Address: 'JWiseman@thecha.org',
    Authorization_Level: 'Observer ',
    Employee_Name: 'Wiseman, Jeffrey L.',
    Id: 37,
    Work_Number: '312.913.7442',
  },
  {
    Authorization_Level: 'Admin',
    Title: 'DEPUTY CHIEF DEVELOPMMENET OFFICER',
    Employee_Name: 'Pratter, Lee E.',
    Department: 'DEVELOPMENT',
    Email_Address: 'LPratter@thecha.org',
    Work_Number: '312.913.7740',
    Organization: 'CHA',
    Id: 59,
  },
  {
    Work_Number: '312.913.7570',
    Id: 31,
    Organization: 'CHA',
    Employee_Name: 'Bobb, Joelle',
    Title: 'FINANCIAL ANALYST',
    Department: 'BUDGET & MANAGEMENT',
    Email_Address: 'jbobb@thecha.org',
    Authorization_Level: 'Observer ',
  },
  {
    Organization: 'CHA',
    Email_Address: 'Aepps@thecha.org',
    Employee_Name: 'Epps, Anna',
    Work_Number: '312.786.3420',
    Title: 'SENIOR PROCUREMENT SPECIALIST',
    Authorization_Level: 'Observer ',
    Id: 56,
    Department: 'PROCUREMENT & CONTRACTS',
  },
  {
    Work_Number: '312.913.7538',
    Employee_Name: 'Muhammad, Bernard',
    Authorization_Level: 'Observer ',
    Email_Address: 'bemuhammad@thecha.org',
    Organization: 'CHA',
    Title: 'FINANCIAL ANALYST',
    Department: "COMPTROLLER'S OFFICE",
    Id: 36,
  },
  {
    Department: 'CAPITAL CONSTRUCTION',
    Id: 14,
    Authorization_Level: 'Observer ',
    Organization: 'CHA',
    Title: 'CONSTRUCTION MANAGER II',
    Email_Address: 'MLaud@thecha.org',
    Work_Number: '312.913.7364',
    Employee_Name: 'Laud, Manuel L.',
  },
  {
    Employee_Name: 'Lopez, Carolina C.',
    Id: 51,
    Department: 'SECTION 3 FIELD OFFICE',
    Email_Address: 'cclopez@thecha.org',
    Title: 'SECTION 3 COORDINATOR',
    Work_Number: '312.913.7724',
    Organization: 'CHA',
    Authorization_Level: 'Observer ',
  },
  {
    Id: 11,
    Title: 'CONSTRUCTION MANAGER I',
    Email_Address: 'jotekiela@thecha.org',
    Work_Number: '312.786.6918',
    Employee_Name: 'Tekiela, Joseph K.',
    Department: 'CAPITAL CONSTRUCTION',
    Organization: 'CHA',
    Authorization_Level: 'Observer ',
  },
  {
    Email_Address: '@cclfchicago.org',
    Employee_Name: 'Wendell Harris',
    Department: '',
    Authorization_Level: 'Observer ',
    Work_Number: '',
    Organization: 'CCLF',
    Id: 67,
    Title: 'Vice President of Lending Operations',
  },
  {
    Department: 'RESIDENT SERVICES',
    Organization: 'CHA',
    Email_Address: 'MPlummer@thecha.org',
    Employee_Name: 'Plummer, Mark A.',
    Title: 'DIRECTOR COMMUNITY SUPPORT',
    Id: 24,
    Work_Number: '312.913.7404',
    Authorization_Level: 'Observer ',
  },
  {
    Organization: 'CHA',
    Title: 'DIRECTOR COMMERCIAL PROPERTIES',
    Authorization_Level: 'Observer ',
    Work_Number: '312.786.6986',
    Id: 23,
    Employee_Name: 'Swann-Thompson, Shemika',
    Department: 'FAMILY INVESTMENT CENTER',
    Email_Address: 'sswann@thecha.org',
  },
  {
    Department: 'BUDGET & MANAGEMENT',
    Authorization_Level: 'Observer ',
    Work_Number: '312.913.7570',
    Email_Address: 'jbobb@thecha.org',
    Title: 'FINANCIAL ANALYST',
    Id: 31,
    Employee_Name: 'Bobb, Joelle',
    Organization: 'CHA',
  },
  {
    Authorization_Level: 'Observer ',
    Employee_Name: 'Seanior, Pamela D.',
    Email_Address: 'PSeanior@thecha.org',
    Id: 58,
    Title: 'SENIOR PROCUREMENT SPECIALIST',
    Work_Number: '312.913.5854',
    Department: 'PROCUREMENT & CONTRACTS',
    Organization: 'CHA',
  },
  {
    Title: 'DIRECTOR DIVERSITY POLICY',
    Organization: 'CHA',
    Employee_Name: 'Lever Ortiz, Sara Scarleth',
    Email_Address: 'slever-Ortiz@thecha.org',
    Department: 'DIVERSITY & INCLUSION',
    Authorization_Level: 'Observer ',
    Id: 29,
    Work_Number: '312.913.7788',
  },
  {
    Work_Number: '312.913.7116',
    Authorization_Level: 'Observer ',
    Employee_Name: 'Bebley, James L.',
    Organization: 'CHA',
    Title: 'CHIEF OPERATING OFFICER',
    Email_Address: 'jbebley@thecha.org',
    Department: 'EXECUTIVE OFFICE',
    Id: 8,
  },
  {
    Department: '',
    Employee_Name: 'Maurice Williams',
    Work_Number: '',
    Email_Address: '@cclfchicago.org',
    Id: 65,
    Title: 'Vice President of Economic Development',
    Authorization_Level: 'Observer ',
    Organization: 'CCLF',
  },
  {
    Email_Address: 'brphillips@thecha.org',
    Id: 48,
    Work_Number: '312.542.8870',
    Authorization_Level: 'Observer ',
    Department: 'SECTION 3 FIELD OFFICE',
    Title: 'SEC 3 HIRING & CONTRACT SPECIALIST',
    Employee_Name: 'Phillips, Brandy S.',
    Organization: 'CHA',
  },
  {
    Employee_Name: 'Sanchez, Tracy L.',
    Department: 'DEVELOPMENT',
    Organization: 'CHA',
    Work_Number: '312.786.3418',
    Email_Address: 'tsanchez@thecha.org',
    Title: 'DEPUTY CHIEF DEVELOPMMENET OFFICER',
    Authorization_Level: 'Admin',
    Id: 60,
  },
  {
    Authorization_Level: 'Admin',
    Email_Address: 'MHarrington@thecha.org',
    Title: 'DEVELOPMENT MONITORING MANAGER',
    Employee_Name: 'Latham, Michelle A.',
    Work_Number: '312.786.3316',
    Organization: 'CHA',
    Id: 20,
    Department: 'DEVELOPMENT',
  },
  {
    Organization: 'CHA',
    Work_Number: '312.913.7662',
    Authorization_Level: 'Observer ',
    Title: 'DIRECTOR DEVELOPMENT CONSTRUCTION',
    Id: 28,
    Department: 'CAPITAL CONSTRUCTION',
    Employee_Name: 'Borkgren, Brent',
    Email_Address: 'BBorkgren@thecha.org',
  },
  {
    Employee_Name: 'Ward, Beverly A.',
    Title: 'FINANCIAL ANALYST',
    Work_Number: '312.913.7702',
    Organization: 'CHA',
    Department: 'BUDGET & MANAGEMENT',
    Id: 34,
    Email_Address: 'BWard@thecha.org',
    Authorization_Level: 'Observer ',
  },
  {
    Email_Address: 'Saikens@thecha.org',
    Work_Number: '312.913.7486',
    Authorization_Level: 'Observer ',
    Title: 'SENIOR PROCUREMENT SPECIALIST',
    Employee_Name: 'Aikens, Sheena',
    Organization: 'CHA',
    Department: 'PROCUREMENT & CONTRACTS',
    Id: 54,
  },
  {
    Authorization_Level: 'Observer ',
    Id: 62,
    Department: '',
    Work_Number: '',
    Title: 'COO and Executive Vice President of Programs',
    Employee_Name: 'Robert Tucker',
    Email_Address: 'rtucker@cclfchicago.org',
    Organization: 'CCLF',
  },
];
